import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState, useRef } from "react";
import DynamicTabs from "../../../components/DynamicTabs";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import CommonButton from "../../../Componants/Common/Button";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import BulkUploadToast from "../../../Componants/Common/Bulk Upload/BulkUploadToast";
import Subheader from "../../../Componants/Common/Subheader";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import FileSaver from "file-saver";
import {
  fetchStockGRNTemplate,
  fetchReferenceCode,
  downloadStockGRNReference,
  uploadStockGRN,
  downloadStockGRNReferenceCode
} from "../../../API Service/apiService";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../../../Componants/Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import BulkUploadSection from "../../../Componants/Common/Bulk Upload/BulkUploadSection";
import { downloadFile } from "../../../utils/downloadHelper";


const StockGRN = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const formik = useFormik({
    initialValues: {
      GRN_reference_number: "",
      GRN_remarks: "",
    },
    validationSchema: Yup.object({
      GRN_reference_number: Yup.string()
        .required("GRN Reference Number is required")
        .matches(/^[a-zA-Z0-9]+$/, "GRN Reference Number must be alphanumeric"),
      GRN_remarks: Yup.string()
        .required("GRN Remarks are required")
        .max(100, "GRN Remarks must be at most 100 characters"),
    }),
    onSubmit: async (values) => {
      if (selectedFile) {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append('GRN_reference_number', values.GRN_reference_number);
          formData.append('GRN_remarks', values.GRN_remarks);
          formData.append('file', selectedFile);
          

          const response = await uploadStockGRN(formData);

          if (response.status === 299) {
            toast((t) => <BulkUploadToast t={t} response={response.data} />, {
              duration: Infinity,
            });
          } else if (response.status === 200) {
            toast.success(response?.message || "Stock GRN uploaded successfully!");
          }

          // Reset form and file input
          formik.resetForm();
          setSelectedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          toast.error(error?.response?.data?.message || "Error uploading Stock GRN. Please try again.");
        } finally {
          setLoading(false);
        }
      } else {
        toast.error("Please select a file to upload.");
      }
    },
  });

  const handleDownloadReferenceCode = async () => {
    try {
      setLoading(true);
      const params = {
         title: "Stock_GRN"
      };
      const response = await downloadStockGRNReferenceCode(params);
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("Reference code downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error downloading reference code:", error);
      toast.error(error.message || "Failed to download reference code");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadStockGRNTemplate = () => {
    downloadFile(`${process.env.REACT_APP_TEMPLETE_URL}/excel/Stock_GRN.xlsx`);
    toast.success("Stock GRN Template downloaded successfully!");
  };


  return (
    <Grid container>
      {loading && <Loader/>}
      <Toaster/>
      <HeaderNavigation value={"Stock GRN"} />
      <DynamicTabs />

      <BulkUploadSection
        onFileChange={handleFileChange}
        onUpload={formik.handleSubmit}
        onDownloadTemplate={handleDownloadStockGRNTemplate}
        onDownloadReference={handleDownloadReferenceCode}
        fileName={selectedFile?.name}
      >
        <Grid container gap={5}>
          <Grid item>
            <TextField
              style={{ width: "12.5rem" }}
              id="GRN_reference_number"
              label="GRN Reference No."
              variant="standard"
              value={formik.values.GRN_reference_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.GRN_reference_number &&
                Boolean(formik.errors.GRN_reference_number)
              }
              helperText={
                formik.touched.GRN_reference_number &&
                formik.errors.GRN_reference_number
              }
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "12.5rem" }}
              id="GRN_remarks"
              label="GRN Remarks"
              variant="standard"
              value={formik.values.GRN_remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.GRN_remarks && Boolean(formik.errors.GRN_remarks)
              }
              helperText={
                formik.touched.GRN_remarks && formik.errors.GRN_remarks
              }
            />
          </Grid>
        </Grid>
      </BulkUploadSection>
    </Grid>
  );
};

export default StockGRN;
